<template>
  <v-dialog
    v-model="dialogData.show"
    width="700"
    transition="slide-y-transition"
    attach
  >
    <v-card>
      <div class="ex-dialog-header">
        <h3>Results: 1200</h3>
        <button @click="close()"><v-icon>close</v-icon></button>
      </div>
      <div class="ex-dialog-body">
        <div class="py-5 text-xs-center" v-if="dialogData.contentIsLoading">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <ul>
          <li
            v-for="item in getAllProducts"
            :key="item.id"
            @click="selectProduct(item.id)">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SelectionDialog',
  props: {
    dialogData: {
      type: Object,
      default: null
    },
    filterShow: {
      type: Object,
      default: null
    }
  },
  methods: {
    close () {
      this.dialogData.show = false
    },
    selectProduct (id) {
      this.$store.commit('productModule/SET_selectedProduct', id)
      this.close()
      this.filterShow.show = false
    }
  },
  computed: {
    getAllProducts () {
      return this.$store.state.productModule.allProducts
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/SelectionDialog.vue